module.exports = __webpack_public_path__ + "img/comprobante_domicilio.e4abb465.svg";